namespace SorAraBul.PropertyManagement {
    export namespace TenantDetailService {
        export const baseUrl = 'PropertyManagement/TenantDetail';

        export declare function Update(request: Serenity.SaveRequest<TenantDetailRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function UpdateStep1(request: Serenity.SaveRequest<TenantDetailRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function StartHasoAuth(request: TenantDetailHasoStartRequest, onSuccess?: (response: TenantDetailHasoProcessResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SkipHasoAuth(request: TenantDetailHasoStartRequest, onSuccess?: (response: TenantDetailHasoProcessResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SendKkbPinCode(request: TenantDetailHasoPinRequest, onSuccess?: (response: TenantDetailHasoProcessResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ReSendKkbPin(request: TenantDetailHasoRequest, onSuccess?: (response: TenantDetailHasoProcessResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function AskKkbReportResult(request: TenantDetailHasoRequest, onSuccess?: (response: TenantDetailHasoProcessResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TenantDetailRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "PropertyManagement/TenantDetail/Update",
            UpdateStep1 = "PropertyManagement/TenantDetail/UpdateStep1",
            StartHasoAuth = "PropertyManagement/TenantDetail/StartHasoAuth",
            SkipHasoAuth = "PropertyManagement/TenantDetail/SkipHasoAuth",
            SendKkbPinCode = "PropertyManagement/TenantDetail/SendKkbPinCode",
            ReSendKkbPin = "PropertyManagement/TenantDetail/ReSendKkbPin",
            AskKkbReportResult = "PropertyManagement/TenantDetail/AskKkbReportResult",
            Retrieve = "PropertyManagement/TenantDetail/Retrieve"
        }

        [
            'Update', 
            'UpdateStep1', 
            'StartHasoAuth', 
            'SkipHasoAuth', 
            'SendKkbPinCode', 
            'ReSendKkbPin', 
            'AskKkbReportResult', 
            'Retrieve'
        ].forEach(x => {
            (<any>TenantDetailService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
